import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TSvgIconProps } from '../icon.component';

const PdsFilledWarningCircle = forwardRef(
  ({ ...props }: TSvgIconProps, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM10 5C10.5523 5 11 5.44772 11 6V11C11 11.5523 10.5523 12 10 12C9.44771 12 9 11.5523 9 11V6C9 5.44772 9.44771 5 10 5ZM9 14C9 13.4477 9.44772 13 10 13C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14Z"
          fill="inherit"
        />
      </svg>
    );
  }
);

export default PdsFilledWarningCircle;
